import { createFallbackIdProvider } from './deviceIdentification/fallbackIdProvider';
import { createLocalStorageIdProvider } from './deviceIdentification/providers/localStorageProvider';
import { createSnowplowIdProvider } from './deviceIdentification/providers/snowplowIdProvider';

const provider = createFallbackIdProvider([
  createSnowplowIdProvider({
    namespace: 'cf',
  }),
  createLocalStorageIdProvider({
    namespace: 'viddsee.local.domain_user_id',
  }),
]);
const domainUserIdPromise = provider.get();
export const getDomainUserId = (): Promise<string | null> => domainUserIdPromise;
